import { useQuery } from 'react-query';
import { fetchWrapper } from 'utils/fetchWrapper';
import type { SparkStepTypeResponse } from 'types/entityTypes/SparkStepType';
import type { DropdownOption } from 'types/common/DropdownOption';
import toastr from 'react-hot-toast';
import { INFINITE_CACHE_AND_STALE_TIME } from 'constants/index';
import { ID_MAP_KEYS } from 'constants/common';
import { generateMap } from 'utilities/hooks/responseHandlers';
import { numericSort } from 'utilities/sort';

const getSparkStepType = () => {
  return fetchWrapper<SparkStepTypeResponse>({
    url: `/SparkStepTypes`,
    method: 'GET',
  });
};

export function useSparkStepTypes() {
  const { data, ...rest } = useQuery('Sparks Step Types', getSparkStepType, {
    onError: (error) => {
      if (error instanceof Error) {
        toastr.error(`failed to Fetch Spark Step Types: ${error.message}`);
      }
    },
    ...INFINITE_CACHE_AND_STALE_TIME,
  });

  const { data: responseData, ...restData } = data || {};

  const idMap = generateMap(responseData, ID_MAP_KEYS.ID);

  const sortedSparkStepTypes = responseData?.sort((a, b) =>
    numericSort(a.attributes.sortOrder, b.attributes.sortOrder)
  );

  const dropdownOptions: DropdownOption[] =
    sortedSparkStepTypes?.map((type) => ({
      label: type.attributes.name,
      value: type.id,
    })) || [];

  const idByKeyMap = sortedSparkStepTypes?.reduce<Record<string, string>>(
    (acc, curr) => {
      return { ...acc, [curr.attributes.key]: curr.id };
    },
    {}
  );

  return {
    sparkStepTypes: sortedSparkStepTypes || [],
    idMap,
    idByKeyMap,
    dropdownOptions,
    ...restData,
    ...rest,
  };
}
